import {Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {RouteService} from '../../../../services/route/route.service';
import {SnackService} from '../../../../services/snack/snack.service';
import {BookingsService} from '../../../../services/bookings/bookings.service';
import {CustomerService} from '../../../../services/customer/customer.service';
import {EventService} from '../../../../services/event/event.service';
import {AuthService} from '../../../../services/auth/auth.service';
import {CartService} from '../../../../services/cart/cart.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatMenuTrigger} from '@angular/material/menu';
import {UtilService} from '../../../../services/util/util.service';
import {StorageService} from '../../../../services/storage/storage.service';
import {ViewService} from '../../../../services/view/view.service';
import {FiscalService} from '../../../../services/fiscal/fiscal.service';
import {PricePipe} from '../../../../pipes/price/price.pipe';
import {PriceInWordsPipe} from '../../../../pipes/priceInWords/priceInWords.pipe';
import {ConfirmDialogComponent} from '../../../../components/confirm-dialog/confirm-dialog.component';
import {LegalPersonService} from '../../../../services/legalPerson/legalPerson.service';
import {
  BaseCheckout,
  BookingGet,
  BookingItemLight,
  BookingStatus,
  BookingTransaction,
  BookingType,
  CartEvent,
  DeliveryType,
  EventLimited,
  LegalPerson,
  LegalPersonCore,
  LegalPersonList,
  LegalPersonSimple,
  PaymentTypeEnum,
  PriceInfoEnum,
  PrintTicketType,
  SendType,
  Waybill,
  WaybillGet
} from '../../../../generated/sales-terminal-client';
import {ADD_TO_CART_ACTION_RESULT, MAX_TICKETS_IN_EMAIL} from '../../sales-terminal.constants';
import {Customer} from '../../../../generated/customer-client';
import {forkJoin, Observable, Subscription, tap} from 'rxjs';
import {cloneDeep, find, orderBy, uniq} from 'lodash-es';
import moment from 'moment';
import * as FileSaver from 'file-saver-es';
import {ValidationService} from '../../../../services/validation/validation.service';
import {ScrollLoad} from '../../../../components/scroll-load-component/ScrollLoad';
import {EmailDialogData, EmailModalComponent} from '../../transactions/email-modal/email-modal.component';
import {InvoiceService} from '../../../../services/invoice/invoice.service';
import {GroupTickets} from '../../cart/cart.constants';
import {PendingChangesComponent} from '../../../../guards/pendingChanges/pending-changes-component';
import {finalize} from 'rxjs/operators';
import {NavigationParameters} from '../../cart/table/cart-table.component';
import {MatFormField} from "@angular/material/form-field";
import {ScrapService} from '../../../../services/scrap/scrap.service';
import {Privileges} from '../../../admin/privileges/privileges.constants';
import {DatePickerConfig} from '../../../../components/datepicker/datepicker.component';
import {TextInputType} from '../../../../components/forms/text-input/text-input.component';
import {NumericInputType} from '../../../../components/forms/numeric-input/numeric-input.component';
import {CentrePropertyService} from "../../../../services/centre-property/centre-property.service";
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-bookings-view',
  templateUrl: './bookings-view.component.html',
  styleUrls: ['./bookings-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BookingsViewComponent implements OnInit, OnDestroy, PendingChangesComponent {
  @ViewChild(MatMenuTrigger) private _promocodeInfoTrigger: MatMenuTrigger;

  private _bookingId: number;
  public contentHidden = false;
  public activeTab = 0;
  public isLoading = false;
  public scrollTop = 0;
  public BookingStatus = BookingStatus;
  public bookingType = BookingType;
  public paymentTypes: PaymentTypeEnum[] = [];
  public legalPersons: LegalPersonSimple[] = [];
  public modalIsOpened = false;
  public modalType: string;
  public isWaybillEdit = false;
  public ticketType: PrintTicketType;
  public printTicketType = PrintTicketType;
  public priceInfo: PriceInfoEnum;
  public priceInfoEnum = PriceInfoEnum;
  public clientEmail: string;
  public clientNotificationEmail: string;
  public bookingDate = '';
  public dueDate = '';
  public waybill: WaybillGet;
  public waybillCustomer: string;
  public transaction: BookingTransaction;
  public customerLegalPerson: LegalPersonList = { id: null, companyName: '' };
  public selectedLegalPerson: LegalPersonList = {} as LegalPersonList;
  public ticketsPrintedCountBy = 'all';
  public backToSale = true;
  public bulkMode = false;
  public groupTickets = GroupTickets;
  public groupTicketsValues: GroupTickets[] = Object.values(GroupTickets);
  public bookingChanged = false;
  public internalCommentChanged = false;
  public disabledButtons: boolean;
  public discount: number;
  public showCustomerForm: boolean;
  public showLegalPersonForm: boolean;
  public highlightPaymentTypeError: boolean;
  public canSelect = false;
  public canEdit = false;
  public initializingView = false;
  public Privileges = Privileges;
  public BookingType = BookingType;
  public isSameOrganiser: boolean;
  private selectedCustomer: Customer;
  private supplier: LegalPersonCore;
  private _subscriptions: Subscription[] = [];

  public eventScrollLoad: ScrollLoad<EventLimited> = this.eventService.getScrollLoad(50);
  public bookingLegalPersonScrollLoad: ScrollLoad<LegalPersonList> = this.legalPersonService.getScrollLoad();
  public bookingCustomerScrollLoad: ScrollLoad<Customer> = this.customerService.getScrollLoad();

  public paidDate: string = moment().utc().add(-1, 'day').toISOString();
  public paidDateConfig: DatePickerConfig = {
    label: 'general.api_reservation_mark_as_paid_date',
    autoBindDates: true, noHint: true,
    maxDate: moment().utc().toISOString()
  }
  public bookingPeriodConfig: DatePickerConfig = {
    label: 'general.api_reservation_list_period',
    range: true, autoBindDates: true, lockStart: true, noHint: true
  }

  @ViewChild('paymentTypeField') paymentTypeFieldElement: MatFormField;

  constructor(public bookingsService: BookingsService,
              public customerService: CustomerService,
              public eventService: EventService,
              public authService: AuthService,
              public centrePropertyService: CentrePropertyService,
              public utilService: UtilService,
              public viewService: ViewService,
              public legalPersonService: LegalPersonService,
              public invoiceService: InvoiceService,
              private routeService: RouteService,
              private snackService: SnackService,
              private cartService: CartService,
              private translateService: TranslateService,
              private storageService: StorageService,
              private dialog: MatDialog,
              private pricePipe: PricePipe,
              private priceInWordsPipe: PriceInWordsPipe,
              private fiscalService: FiscalService,
              private scrapService: ScrapService,
              private route: ActivatedRoute) {}

  public ngOnInit(): void {
    this.route.params.subscribe(val => {
      this.initView();
    })
    this._subscriptions.push(this.utilService.fiscalOperationFailed.subscribe(() => this.initView()));
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._subscriptions = [];
  }

  public get booking(): BookingGet {
    return this.bookingsService.currentBookingMap[this._bookingId];
  }

  public get zippedTicketsSent(): boolean {
    return this.bookingsService.getSelectedTicketIds.length > MAX_TICKETS_IN_EMAIL;
  }

  private initView(item: BookingGet = null): void {
    if (this.initializingView) {return;}
    this.initializingView = true;
    this.closeModal();
    if (item) {
      this.routeService.replaceUrl('/app/sales-terminal/bookings/view/' + item.id + (this.modalType === 'waybill' ? '/waybill' : ''));
    }
    this.cartService.clearBooking();
    this.cartService.getPaymentTypes().subscribe((paymentTypes) => this.paymentTypes = paymentTypes);
    this._bookingId = this.routeService.params['id'] ? parseFloat(this.routeService.params['id']) : item?.id;
    this.bookingsService.getBooking(this._bookingId).pipe(
      finalize(() => this.initializingView = false)
    ).subscribe((booking) => {
      this.bookingsService.updateCurrentBooking(booking);
      this.bookingsService.selectAllTickets();
      this.canEdit = this.isActive && this.authService.checkPrivileges(Privileges.BOOKING_CHANGE);
      this.canSelect = this.isActive && this.authService.checkPrivileges([Privileges.BOOKING_CHANGE]);
      this.selectedCustomer = this.booking.customer;
      this.bookingDate = moment(this.booking.bookingDate, 'X').format();
      this.dueDate = moment(this.booking.dueDate, 'X').format();
      this.ticketType = PrintTicketType.Plp;
      this.priceInfo = PriceInfoEnum.Regular;
      this.customerService.getLegals().subscribe((legalPersons) => {
        this.legalPersons = orderBy(legalPersons, ['name'], ['asc']);
        const lp = find(this.legalPersons, { id: this.booking.legalPersonId });
        this.selectedLegalPerson = lp && { id: lp.id, companyName: lp.name } || { id: null, companyName: '' };
        this.customerLegalPerson = this.selectedLegalPerson;
        if (this.customerLegalPerson.id) {
          this.bookingLegalPersonScrollLoad.object = this.customerLegalPerson;
        }
      });
      if (this.isPromoter) {
        this.eventService.isSameOrganiser(uniq(this.bookingsService.cartEventIds))
          .subscribe((value) => this.isSameOrganiser = value.result);
      }
      if (this.booking.customer?.uuid) {
        this.bookingCustomerScrollLoad.object = this.booking.customer;
      }
      if (this.isWaybill && !item) {
        this.initWaybill();
      }
      this.bookingsService.updateSelectionMap();
      if (this.authService.checkSalespointProperty('tickets_printed_in_pdf')) {
        this.ticketType = PrintTicketType.Pdf;
      }
      this.clientNotificationEmail = this.selectedCustomer?.email || '';
      this.discount = this.bookingsService.cart.discountPercent;
    });
  }

  public get isPromoter(): boolean {
    return this.authService.checkPrivileges(Privileges.BOOKING_CREATE_PROMOTER) || this.authService.user.isPromoter;
  }

  public get hasParentBooking(): boolean {
    return this.booking?.parentBookingId !== this.booking?.id;
  }

  public get canPartiallyCancel(): boolean {
    return this.authService.checkPrivileges(Privileges.BOOKING_CHANGE) &&
      this.bookingsService.hasMoreThanOneTicket && this.bookingsService.hasSelectedTickets && !this.bookingsService.areAllTicketsSelected;
  }

  public get isReleaseAllowed(): boolean {
    return (((this.booking?.paymentType !== 'transfer' || this.booking?.receivedPayment) &&
        this.authService.checkPrivileges(Privileges.BOOKING_RELEASE)) || this.authService.checkPrivileges(Privileges.BOOKING_RELEASE_WITHOUT_PAYMENT)) &&
      this.bookingsService.hasSelectedTickets;
  }

  public get isWaybill(): boolean {
    return this.routeService.checkRoute(['sales-terminal', 'bookings', 'view', this.booking?.id.toString(), 'waybill']);
  }

  public get deliveryType(): DeliveryType {
    return find(this.booking.deliveryTypes, { id: this.booking?.deliveryTypeId }) || null;
  }

  public get isValid(): boolean {
    return !(this.booking.type !== this.bookingType.Organiser && !this.booking.customer?.uuid && !this.booking.customer?.firstName);
  }

  public isValidEmail(email: string): boolean {
    return email && ValidationService.validateEmail(email);
  }

  public markAsPaid(): void {
    this.startLoader();
    const paid = moment(this.paidDate).endOf('day').unix();
    this.bookingsService.markAsPaid(this.booking.id, paid).pipe(
      tap({ error: (e) => this.bookingsService.retryCart() }),
      finalize(() => this.stopLoader())
    ).subscribe((booking) => {
      booking.receivedPayment = paid;
      this.bookingsService.updateCart(booking);
      this.snackService.showSuccess(this.translateService.instant('general.api_reservation_successfully_marked_as_paid'));
    });
  }

  public markAsUnpaid(): void {
    this.startLoader();
    this.bookingsService.markAsUnpaid(this.booking.id).pipe(
      tap({ error: (e) => this.bookingsService.retryCart() }),
      finalize(() => this.stopLoader())
    ).subscribe((booking) => {
      booking.receivedPayment = 0;
      this.bookingsService.updateCart(booking);
      this.snackService.showSuccess(this.translateService.instant('general.api_reservation_successfully_marked_as_unpaid'));
    });
  }

  public openTransaction(): void {
    if (this.booking.transactionId) {
      this.routeService.navigate('/app/sales-terminal/transactions/view/' + this.booking.transactionId);
    } else {
      this.snackService.showError(this.translateService.instant('general.api_reservation_no_transaction'));
    }
  }

  public saveBookingChanges(): void {
    this.startLoader();
    if (this.internalCommentChanged && !this.bookingChanged) {
      this.saveInternalCommentChange();
    }
    if (this.bookingChanged) {
      this.bookingsService.changeBooking({
        customerUuid: this.booking.customer?.uuid || '',
        paymentType: this.booking.paymentType,
        deliveryTypeId: this.booking.deliveryTypeId,
        notes: this.booking.notes,
        dueDate: moment(this.dueDate).endOf('day').unix(),
        legalPersonId: this.booking.legalPersonId
      }).pipe(
        tap({ error: (e) => this.bookingsService.retryCart() }),
        finalize(() => this.stopLoader())
      ).subscribe((booking) => {
        this.bookingChanged = false;
        if (this.internalCommentChanged) {
          this.saveInternalCommentChange();
        } else {
          this.finishBookingChange(booking);
        }
      });
    }
  }

  private saveInternalCommentChange(): void {
    this.bookingsService.updateInternalComment(this.booking.internalComment).pipe(
      tap({ error: (e) => this.bookingsService.retryCart() }),
      finalize(() => this.stopLoader())
    ).subscribe((booking) => {
      this.internalCommentChanged = false;
      this.finishBookingChange(booking);
    });
  }

  private finishBookingChange(newBooking: BookingGet): void {
    this.bookingsService.updateCart(newBooking);
    this.snackService.showSuccess(this.translateService.instant('general.api_reservation_change_succeed'));
  }

  public closeModal(): void {
    this.modalType = '';
    this.modalIsOpened = false;
    this.contentHidden = false;
  }

  public openIssueModal(): void {
    if (this.booking.type !== BookingType.Organiser && !this.booking.paymentType) {
      this.highlightPaymentTypeError = true;
      this.activeTab = 2;
      setTimeout(() => {
        this.utilService.isMobile && this.paymentTypeFieldElement._elementRef.nativeElement && this.paymentTypeFieldElement._elementRef.nativeElement.scrollIntoView({ behavior: "smooth" });
      }, 0)
    } else {
      if (this.bookingChanged || this.internalCommentChanged) {
        this.saveBookingChanges();
      }
      this.contentHidden = this.utilService.isMobile;
      this.modalIsOpened = true;
      this.modalType = 'issue';
      this.highlightPaymentTypeError = false;
    }
  }

  public splitBooking(): void {
    this.startLoader();
    this.bookingsService.splitBooking({
      tickets: this.bookingsService.getSelectedTicketIds,
    }).pipe(
      tap({ error: (e) => this.bookingsService.retryCart() }),
      finalize(() => this.stopLoader())
    ).subscribe((booking) => {
      this.routeService.navigate('/app/sales-terminal/bookings/view/' + booking.id);
      this.snackService.showSuccess(this.translateService.instant('general.api_reservation_split_succeed'));
    });
  }

  public openEmailModal(): void {
    this.contentHidden = this.utilService.isMobile;
    this.modalIsOpened = true;
    this.modalType = 'sendEmail';
    if (this.booking.customer) {
      this.clientEmail = this.booking.customer.email;
    }
    if (this.clientNotificationEmail?.length) {
      this.clientEmail = this.clientNotificationEmail;
    }
  }

  public releaseBooking(): void {
    this.disabledButtons = true;
    const baseCheckout: BaseCheckout = {
      tickets: this.bookingsService.getSelectedTicketIds,
      backToSale: this.backToSale,
      clientNotificationEmail: this.clientNotificationEmail
    };
    if (this.authService.checkSalespointProperty('fiscal_procedures_by')) {
      this.fiscalService.bookingCheckout(baseCheckout, this.booking.id).subscribe(() => {
        this.fiscalService.printTransaction(this.priceInfo)
          .subscribe((blob) => this.printTickets(blob));
      });
    } else {
      this.bookingsService.releaseBooking(baseCheckout).subscribe((transaction: BookingTransaction) => {
        this.transaction = transaction;
        this.cartService.printTransaction(this.transaction.id, this.ticketType, this.priceInfo)
          .subscribe((blob) => this.printTickets(blob));
      });
    }
  }

  private printTickets(blob: Blob): void {
    this.storageService.set(UtilService.STORAGE_CONTENT_SCROLL, 0);
    this.contentHidden = this.utilService.isMobile;
    this.modalIsOpened = true;
    this.modalType = 'confirmPrint';
    const legalPerson = this.booking.legalPersonId && find(this.booking.customer.legalPersons, { id: this.booking.legalPersonId });
    const baseEvent: CartEvent = this.bookingsService.events[0];
    let fileName = (legalPerson ? legalPerson.name : ((this.booking.customer?.firstName + this.booking.customer?.lastName) || 'ticket')) +
      (baseEvent ? '_' + baseEvent.title[0].value + moment(baseEvent.eventDate.start).format('DDMMYYYY') + '_' + this.bookingsService.ticketCount : '');
    const fileData = UtilService.getFileData('', this.ticketType);
    let file: any;
    if (this.ticketType === PrintTicketType.Plp && fileData.firefox) {
      file = new File([blob], fileData.filename, { type: fileData.mime });
      window.location.href = URL.createObjectURL(file);
    } else {
      file = new Blob([blob], { type: fileData.mime });
      if (this.ticketType === PrintTicketType.Plp) {
        FileSaver.saveAs(file, fileData.filename);
      } else {
        fileName = fileName.replace(' ', '');
        if (this.utilService.isMobile) {
          this.utilService.mobileDownload(file, fileName + '.pdf');
        } else {
          this.utilService.previewOrPrintFile(file, null, null, PrintTicketType.Pdf, fileName, this.ticketsPrintedCountBy);
        }
      }
    }
    if (this.authService.checkSalespointProperty('fiscal_procedures_by')) {
      this.fiscalService.getOperationStatus();
    }
    this.priceInfo = PriceInfoEnum.Regular;
    this.disabledButtons = false;
    if (this.transaction.splitBookingId) {
      this.routeService.navigate('/app/sales-terminal/bookings/view/' + this.transaction.splitBookingId);
    }
  }

  public proceedTransaction(): void {
    this.disabledButtons = true;
    const baseCheckout: BaseCheckout = {
      tickets: this.bookingsService.getSelectedTicketIds,
      backToSale: this.backToSale,
      clientNotificationEmail: this.clientNotificationEmail
    };
    this.bookingsService.releaseBooking(baseCheckout).subscribe((transaction) => {
      this.transaction = transaction;
      this.cartService.sendTransaction(this.transaction.id, SendType.Client, this.priceInfo, [], { email: this.clientEmail }).subscribe(() => {
        this.snackService.showSuccess(this.translateService.instant('general.api_booking_release_succeed'));
        this.initView();
      })
    });
  }

  public cancelBookingPartial(ticketIds: number[] = this.bookingsService.getSelectedTicketIds): void {
    const dialogConfig: MatDialogConfig = {
      width: '60%',
      panelClass: 'xs-popup',
      data: {
        title: this.translateService.instant('general.api_reservation_confirm_partial_cancel_title'),
        description: this.translateService.instant('general.api_reservation_confirm_partial_cancel_description'),
        buttonCancel: this.translateService.instant('general.api_reservation_confirm_partial_cancel_button_cancel'),
        buttonOk: this.translateService.instant('general.api_reservation_confirm_partial_cancel_button_ok')
      }
    };
    if (!this.bookingsService.cartDraftEvent?.isDraft) {
      dialogConfig.data.additionalActions = [
        {
          title: this.translateService.instant('general.api_reservation_confirm_partial_cancel_button_ok_and_add_to_cart'),
          result: ADD_TO_CART_ACTION_RESULT
        }
      ];
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.startLoader();
        if (this.bookingsService.areAllTicketsSelected) {
          this.cancel();
          this.stopLoader();
        } else {
          const toCart: boolean = typeof res === 'string' && res === ADD_TO_CART_ACTION_RESULT;
          this.bookingsService.cancelBookingTickets({ tickets: ticketIds }, toCart).pipe(
            finalize(() => {
              this.cartService.getCart().pipe(
                finalize(() => this.stopLoader())
              ).subscribe();
            })
          ).subscribe((booking) => this.bookingsService.updateCart(booking));
        }
      }
    });
  }

  public confirmPrinting(): void {
    if (this.authService.checkSalespointProperty('fiscal_procedures_lt')) {
      this.cartService.printFiscal(this.transaction.id).subscribe((blob) => {
        const fileData = UtilService.getFileData('json_fiscal', 'json');
        if (fileData.firefox) {
          window.location.href = URL.createObjectURL(new File([blob], fileData.filename, { type: fileData.mime }));
        } else {
          FileSaver.saveAs(new Blob([blob], { type: fileData.mime }), fileData.filename);
        }
        this.finishPrinting();
      });
    } else {
      this.finishPrinting();
    }
  }

  private finishPrinting(): void {
    this.snackService.showSuccess(this.translateService.instant('general.api_reservation_release_succeed'));
    this.initView();
  }

  // TODO remove once new invoice download is implemented
  public downloadInvoice(booking: BookingGet): void {
    this.bookingsService.getInvoice(booking.customer.uuid, booking.legalPersonId, booking.id).subscribe((blob) => {
      const legalPerson = booking.legalPersonId && find(booking.customer.legalPersons, { id: booking.legalPersonId });
      const fileName = (legalPerson ? legalPerson.name : (booking.customer.firstName + booking.customer.lastName)) + '_' + booking.invoiceNumber +
        '_' + moment(booking.dueDate).add(-1, 'day').format('DDMMYYYY');
      const fileData = UtilService.getFileData(fileName, 'html');
      this.utilService.previewOrPrintFile(
        new Blob([blob], { type: fileData.mime }),
        '@media print { @page { size: portrait; margin: 0; } html { margin: 0 !important; padding: 0 !important; } body { margin: 10mm !important; padding: 0 !important; } * { font-size: 12px; } }',
        'invoice' + booking.id,
        'html',
        fileName.replace(' ', '')
      );
    });
  }

  public openWaybill(): void {
    this.bookingsService.openedFromList = false;
    const waybillRequest = this.bookingsService.getWaybill(this.booking.id);
    const supplierRequest = this.legalPersonService.getLegalPersonByOwnCentre();
    this.startLoader();
    forkJoin([waybillRequest, supplierRequest]).pipe(
      finalize(() => this.stopLoader())
    ).subscribe(results => {
      this.waybill = results[0];
      this.waybillCustomer = this.booking.customer?.uuid || '';
      this.supplier = results[1];
      this.printWaybill();
    });
  }

  private printWaybill(): void {
    let tickets = '', vatTotal = 0, itemsTotal = 0;
    this.waybill.items.forEach((product, idx) => {
      const vat = product.unitPrice * (product.vatPercentage / 100);
      vatTotal += vat;
      itemsTotal += product.amount;
      tickets +=
        '<tr class="align-right">' +
        '<td class="align-center">' + (idx + 1) + '</td>' +
        '<td class="align-left">' + product.name + '</td>' +
        '<td class="align-center">' + this.translateService.instant('general.api_cart_table_pcs') + '</td>' +
        '<td class="align-right">' + product.amount + '</td>' +
        '<td class="align-right">' + this.pricePipe.transform(product.unitPrice, true) + '</td>' +
        '<td class="align-right">' + this.pricePipe.transform(vat, true) + '</td>' +
        '<td class="align-right">' + (product.vatPercentage > 0 ? product.vatPercentage + '%' : this.translateService.instant('general.api_reservation_waybill_print_table_without_vat')) + '</td>' +
        '<td class="align-right">' + this.pricePipe.transform(product.unitPrice + vat, true) + '</td>' +
        '<td class="align-right">' + this.pricePipe.transform(product.sum, true) + '</td>' +
        '<td>&nbsp;</td>' +
        '</tr>';
    });

    const totals =
      '<tr class="bold" class="align-right">' +
      '<td>&nbsp;</td>' +
      '<td class="align-left">' + this.translateService.instant('general.api_cart_table_total') + '</td>' +
      '<td class="align-center">&nbsp;</td>' +
      '<td class="align-right">' + itemsTotal + '</td>' +
      '<td class="align-center">&nbsp;</td>' +
      '<td class="align-right">' + this.pricePipe.transform(vatTotal, true) + '</td>' +
      '<td class="align-center">&nbsp;</td>' +
      '<td class="align-right">&nbsp;</td>' +
      '<td class="align-right">' + this.pricePipe.transform(this.waybill.itemsTotal, true) + '</td>' +
      '<td>&nbsp;</td>' +
      '</tr>';

    const html =
      '<html>' +
      '<head>' +
      '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8">' +
      '<title>' + this.viewService.conf.pageTitle + '</title>' +
      '<style media="all" type="text/css">' +
      '@page {size: A4;}' +
      'body {width:833px;}' +
      'table {border-collapse:collapse;table-layout:fixed;margin-left:auto;margin-right:auto;}' +
      'tr, td, th {padding-left:2px;padding-right:2px;font-family:sans-serif;font-size:12px;}' +
      'th {padding-top:6px;padding-bottom:6px;}' +
      'hr {margin-top:-2px;}' +
      '.bordered table, .bordered td, .bordered th {border:1px solid black;}' +
      '.bold {font-weight:bold;}' +
      '.lined td, .lined hr {padding-left:20px;}' +
      '.underline {margin-top:-8px;font-size:11px;}' +
      '.secondary p {padding-left:166px;}' +
      '.compact hr {margin-left:166px;margin-top:-2px;}' +
      '.align-center {text-align:center;}' +
      '.align-left {text-align:left;}' +
      '.align-right {text-align:right;}' +
      '</style>' +
      '</head>' +
      '<body>' +
      '<table class="bordered" style="margin-top:50px">' +
      '<tbody>' +
      '<tr class="align-center">' +
      '<th width="40px" nowrap=""></th>' +
      '<th width="120px" nowrap="">' + this.translateService.instant('general.api_reservation_waybill_print_supplier') + '</th>' +
      '<th width="120px" nowrap="">' + this.translateService.instant('general.api_reservation_waybill_print_recipient') + '</th>' +
      '</tr>' +
      '<tr class="bold" class="align-center">' +
      '<td>' + this.translateService.instant('general.api_reservation_waybill_print_vat_code') + '</td>' +
      '<td>' + this.supplier.vatCode + '</td>' +
      '<td>' + (this.waybill.customerLegalPerson ? this.waybill.customerLegalPerson.vatCode : '-') + '</td>' +
      '</tr>' +
      '</tbody>' +
      '</table>' +
      '<table width="80%" style="margin-top:110px">' +
      '<tbody>' +
      '<tr>' +
      '<td width="50%" class="align-right"><b>' + this.translateService.instant('general.api_reservation_waybill_print_date') + ':</b></td>' +
      '<td width="50%" class="align-left">' + this.waybill.created + '</td>' +
      '</tr>' +
      '<tr><td colspan="2">&nbsp;</td></tr><tr class="align-left">' +
      '<th nowrap="" colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_supplier') + '</th>' +
      '</tr>' +
      '<tr class="lined">' +
      '<td colspan="2">&nbsp;' + this.supplier.companyName + ', ' + this.translateService.instant('general.api_reservation_waybill_print_address') + ': ' +
      this.supplier.address.city + ', ' + this.supplier.address.street + ', ' + this.supplier.address.postalCode + ', ' + this.supplier.address.countryCode + '</td>' +
      '</tr>' +
      '<tr class="lined">' +
      '<td colspan="2"><hr></td>' +
      '</tr>' +
      '<tr class="align-center">' +
      '<td colspan="2"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_side_description') + ')</p></td>' +
      '</tr>' +
      '<tr class="align-left">' +
      '<th nowrap="" colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_recipient') + '</th>' +
      '</tr>' +
      '<tr class="lined">' +
      '<td colspan="2">&nbsp;' + (this.waybill.customerLegalPerson ? this.waybill.customerLegalPerson.companyName : (this.booking.customer?.firstName || '') + ' ' + (this.booking.customer?.lastName || '')) +
      ', ' + this.translateService.instant('general.api_reservation_waybill_print_address') + ': ' +
      (this.waybill.customerLegalPerson?.address ? this.waybill.customerLegalPerson.address.city + ', ' + this.waybill.customerLegalPerson.address.street + ', ' + this.waybill.customerLegalPerson.address.postalCode +
        ', ' + this.waybill.customerLegalPerson.address.countryCode : '-') + '</td>' +
      '</tr>' +
      '<tr class="lined">' +
      '<td colspan="2"><hr></td>' +
      '</tr>' +
      '<tr class="align-center">' +
      '<td colspan="2"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_side_description') + ')</p></td>' +
      '</tr>' +
      '<tr class="align-left">' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_shipment_basis') + '</th>' +
      '<td nowrap=""><p style="margin-left:-198px">' + this.waybill.shipmentBasis + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="2"><hr width="80%" style="margin-left:132px;margin-top:-8px"></td>' +
      '</tr>' +
      '<tr class="align-center">' +
      '<td colspan="2"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_shipment_basis_description') + ')</p></td>' +
      '</tr>' +
      '</tbody>' +
      '</table>' +
      '<table width="80%" class="bordered" style="margin-top:10px">' +
      '<tbody>' +
      '<tr class="align-center">' +
      '<th width="3%">&nbsp;</th>' +
      '<th width="28%">' + this.translateService.instant('general.api_reservation_waybill_print_product_section') + '</th>' +
      '<th width="7%">&nbsp;</th>' +
      '<th width="9%">&nbsp;</th>' +
      '<th width="9%">&nbsp;</th>' +
      '<th width="10%">&nbsp;</th>' +
      '<th width="8%">&nbsp;</th>' +
      '<th width="10%">&nbsp;</th>' +
      '<th width="10%">&nbsp;</th>' +
      '<th width="13%">&nbsp;</th>' +
      '</tr>' +
      '<tr class="align-center">' +
      '<th>№</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_product_name') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_measure_unit') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_quantity') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_price') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_vat_sum') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_vat_percentage') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_vat_included') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_total_sum') + '</th>' +
      '<th>' + this.translateService.instant('general.api_reservation_waybill_print_table_comments') + '</th>' +
      '</tr>' +
      tickets +
      totals +
      '</tbody>' +
      '</table>' +
      '<table width="80%" style="margin-top:4px">' +
      '<tbody>' +
      '<tr>' +
      '<th width="50%" class="align-left">' + this.translateService.instant('general.api_reservation_waybill_print_total_vat') + ':&nbsp;</th>' +
      '<td width="50%" nowrap=""><p style="margin-left:-166px">&nbsp;' + (vatTotal > 0 ? this.priceInWordsPipe.transform(vatTotal) :
        this.translateService.instant('general.api_reservation_waybill_print_table_without_vat')) + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="2"><hr width="75%" style="margin-left:166px;margin-top:-8px"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="2"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_in_words') + ')</p></td>' +
      '</tr>' +
      '<tr>' +
      '<th width="50%" class="align-left">' + this.translateService.instant('general.api_reservation_waybill_print_total_sum_with_vat') + ':&nbsp;</th>' +
      '<td width="50%" nowrap=""><p style="margin-left:-166px">&nbsp;' + this.priceInWordsPipe.transform(this.waybill.itemsTotal) + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="2"><hr width="75%" style="margin-left:166px;margin-top:-8px"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="2"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_in_words') + ')</p></td>' +
      '</tr>' +
      '</tbody>' +
      '</table>' +
      '<table width="80%" class="compact">' +
      '<tbody' +
      '<tr>' +
      '<td width="50%" colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_licensor') + ':&nbsp;</td>' +
      '<td width="50%" colspan="2"><p style="margin-left:-166px">&nbsp;' + (this.waybill.licensor || '-') + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="4"><hr width="75%"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="4"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_licensor_description') + ')</p></td>' +
      '</tr>' +
      '<tr>' +
      '<td colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_supplier_alt') + ':&nbsp;</td>' +
      '<td colspan="2"><p style="margin-left:-166px">&nbsp;' + (this.waybill.supplier || '-') + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="4"><hr width="75%"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="4"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_supplier_description') + ')</p></td>' +
      '</tr>' +
      '<tr>' +
      '<td colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_deliverer') + ':&nbsp;</td>' +
      '<td colspan="2"><p style="margin-left:-166px">&nbsp;' + (this.waybill.deliverer || '-') + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="4"><hr width="75%"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="4"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_deliverer_description') + ')</p></td>' +
      '</tr>' +
      '<tr>' +
      '<td>' + this.translateService.instant('general.api_reservation_waybill_print_authority') + ':&nbsp;</td>' +
      '<td><p style="margin-left:1px">&nbsp;' + (this.waybill.mandate || '-') + '</p></td>' +
      '<td><p style="margin-left:-26px">' + this.translateService.instant('general.api_reservation_waybill_print_authority_for') + ':&nbsp;</p><p></p></td>' +
      '<td><p style="margin-left:-132px">&nbsp;' + (this.waybill.authority || '-') + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="2"><hr width="40%"></td>' +
      '<td colspan="2"><hr width="90%" style="margin-left:32px"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="2"><p class="underline" style="margin-left:-30px">(' + this.translateService.instant('general.api_reservation_waybill_print_authority_description') + ')</p></td>' +
      '<td colspan="2"><p class="underline" style="margin-left:-134px">(' + this.translateService.instant('general.api_reservation_waybill_print_authority_for_description') + ')</p></td>' +
      '</tr>' +
      '<tr>' +
      '<td colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_recipient_alt') + ':&nbsp;</td>' +
      '<td colspan="2"><p style="margin-left:-166px">&nbsp;' + (this.waybill.recipient || '-') + '</p></td>' +
      '</tr>' +
      '<tr class="align-right">' +
      '<td colspan="4"><hr width="75%"></td>' +
      '</tr>' +
      '<tr class="align-center secondary">' +
      '<td colspan="4"><p class="underline">(' + this.translateService.instant('general.api_reservation_waybill_print_recipient_description') + ')</p></td>' +
      '</tr>' +
      '</tbody>' +
      '</table>' +
      '<table width="80%" style="margin-top:0px">' +
      '<tbody>' +
      '<tr class="align-left">' +
      '<th nowrap="" colspan="2">' + this.translateService.instant('general.api_reservation_waybill_print_attachments') + '</th>' +
      '</tr>' +
      '<tr class="lined">' +
      '<td colspan="2">&nbsp;' + (this.waybill.attachments || '-') + '</td>' +
      '</tr>' +
      '<tr class="lined">' +
      '<td colspan="2"><hr></td>' +
      '</tr>' +
      '</tbody>' +
      '</table>' +
      '</body>' +
      '</html>';
    const file = new Blob([html], { type: 'text/html' });
    const styles = '@media print { @page { size: portrait; margin: 0; } html { margin: 0 !important; padding: 0 !important; } body { margin: 10mm !important; padding: 0 !important; } * { font-size: 12px; } }';
    this.utilService.previewOrPrintFile(file, styles, 'waybill' + this.booking.id);
  }

  public createWaybill() {
    this.bookingsService.openedFromList = false;
    this.routeService.replaceUrl('/app/sales-terminal/bookings/view/' + this.booking.id + '/waybill');
    this.initWaybill();
  }

  private initWaybill(): void {
    this.contentHidden = this.utilService.isMobile;
    this.modalIsOpened = true;
    this.modalType = 'waybill';
    this.isWaybillEdit = false;
    if (this.waybill && this.waybill.shipmentBasis) {
      this.isWaybillEdit = true;
    } else {
      this.waybill = {
        shipmentBasis: this.translateService.instant('general.api_reservation_invoice_nr') + ' ' + this.booking.invoiceNumber + ' ' +
          this.translateService.instant('general.api_reservation_dated_from') + ' ' + moment().format(this.viewService.conf.dateFormat)
      };
      this.waybillCustomer = '';
    }
  }

  public changeWaybill(): void {
    this.startLoader();
    this.routeService.replaceUrl('/app/sales-terminal/bookings/view/' + this.booking.id + '/waybill');
    this.bookingsService.getWaybill(this.booking.id).pipe(
      finalize(() => this.stopLoader())
    ).subscribe((waybill) => this.waybill = waybill);
  }

  public cancelWaybill(): void {
    this.closeModal();
    if (this.bookingsService.openedFromList) {
      this.routeService.navigate('/app/sales-terminal/bookings');
      this.bookingsService.openedFromList = false;
    } else {
      this.routeService.navigate('/app/sales-terminal/bookings/view/' + this.booking.id);
    }
  }

  public proceedWaybill(): void {
    const data: Waybill = cloneDeep(this.waybill) as Waybill;
    this.bookingsService.addWaybill(data).subscribe((response) => {
      this.snackService.showSuccess(this.translateService.instant('general.' + response.message));
      this.routeService.replaceUrl('/app/sales-terminal/bookings/view/' + this.booking.id);
    });
  }

  public get isValidWaybill(): boolean {
    return !!(this.booking.customer && this.waybill.shipmentBasis);
  }

  public scrappingProcess(): void {
    const cart = cloneDeep(this.bookingsService.cart);
    cart.events = [];
    this.bookingsService.cart.events.forEach(event => {
      const selectedEvent = cloneDeep(event);
      selectedEvent.legacyTickets = event.legacyTickets.filter(ticket => this.bookingsService.getSelectedTicketIds.includes(ticket.id));
      if (selectedEvent.legacyTickets?.length) {
        cart.events.push(selectedEvent);
      }
    });
    this.scrapService.cart = cart;
    this.routeService.navigate('/app/sales-terminal/booking-scrap/' + this.booking.id);
  }

  public cancel(): void {
    const dialogConfig: MatDialogConfig = {
      height: '10%',
      width: '40%',
      panelClass: 'xs-popup',
      data: {
        title: this.translateService.instant('general.api_reservation_confirm_cancel_title'),
        description: this.translateService.instant('general.api_reservation_confirm_cancel_description'),
        buttonCancel: this.translateService.instant('general.api_reservation_confirm_cancel_button_cancel'),
        buttonOk: this.translateService.instant('general.api_reservation_confirm_cancel_button_ok')
      }
    };
    if (!this.bookingsService.cartDraftEvent?.isDraft) {
      dialogConfig.data.additionalActions = [
        {
          title: this.translateService.instant('general.api_reservation_confirm_cancel_button_ok_and_add_to_cart'),
          result: ADD_TO_CART_ACTION_RESULT
        }
      ];
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.startLoader();
        this.bookingsService.cancelBooking(typeof res === 'string' && res === ADD_TO_CART_ACTION_RESULT).subscribe(() => {
          this.cartService.getCart().pipe(
            finalize(() => this.stopLoader())
          ).subscribe(() => {
            this.snackService.showSuccess(this.translateService.instant('general.api_reservation_cancel_succeed'));
            this.toList();
          });
        });
      }
    });
  }

  public toList(): void {
    this.routeService.navigate('/app/sales-terminal/bookings');
  }

  public toInitial(): void {
    this.routeService.navigate('/app/sales-terminal/bookings/view/' + this.booking.parentBookingId);
  }

  public get isActive(): boolean {
    return this.booking?.status === BookingStatus.Active;
  }

  public get isReleased(): boolean {
    return this.booking?.status === BookingStatus.Released;
  }

  public get isCancelled(): boolean {
    return this.booking?.status === BookingStatus.Cancelled;
  }

  public get canSplit(): boolean {
    return this.authService.checkPrivileges(Privileges.BOOKING_CHANGE) &&
      this.bookingsService.hasMoreThanOneTicket && this.bookingsService.hasSelectedTickets;
  }

  public selectBookingLegalPerson(): void {
    const check = find(this.legalPersons, { id: this.booking.legalPersonId });
    if (!check) {
      this.legalPersons = [];
      this.booking.customer = {} as Customer;
      this.selectedCustomer = this.booking.customer;
      this.bookingCustomerScrollLoad.reset();
    }
    if (this.bookingLegalPersonScrollLoad.object?.id) {
      this.selectedLegalPerson = this.bookingLegalPersonScrollLoad.object;
    }
    this.bookingChanged = true;
  }

  public selectBookingCustomer(): void {
    if (this.bookingCustomerScrollLoad.object?.uuid) {
      this.booking.customer = this.bookingCustomerScrollLoad.object;
      this.selectedCustomer = this.booking.customer;
      if (this.booking?.customer && this.booking.customer.email) {
        this.clientNotificationEmail = this.booking.customer.email;
      }
      if (this.isWaybill) {
        this.saveBookingChanges();
      }
    }
    this.bookingChanged = true;
  }

  public legalPersonDisplay(legalPerson: LegalPersonList): string {
    return '<b>' + legalPerson.companyName + '</b><span *ngIf="legalPerson.regNumber">&nbsp;(' + legalPerson.regNumber.split('').join('&#8203;') + ')</span>';
  }

  public navigateToEventView(navParams: NavigationParameters): void {
    if (navParams.rememberBooking) {
      this.cartService.updateCurrentBooking(this.booking as BookingItemLight);
    } else {
      this.cartService.updateCurrentBooking(null);
    }
    this.routeService.navigate('/app/sales-terminal/search/event/' + navParams.eventId);
  }

  public navigateToEventSearchView(): void {
    this.cartService.updateCurrentBooking(this.booking as BookingItemLight);
    this.routeService.navigate('/app/sales-terminal/search');
  }

  public startLoader(): void {
    this.scrollTop = cloneDeep(this.utilService.contentScrolledTop);
    this.isLoading = true;
  }

  public stopLoader(): void {
    this.isLoading = false;
    this.storageService.set(UtilService.STORAGE_CONTENT_SCROLL, this.scrollTop);
  }

  public get canBulkChange(): boolean {
    return this.bookingsService.hasMoreThanOneTicket;
  }

  public toggleBulkMode(): void {
    this.bulkMode = !this.bulkMode;
    if (!this.bulkMode) {
      this.bookingsService.groupTicketsBy = GroupTickets.None;
    } else if (this.bookingsService.groupTicketsBy === GroupTickets.None) {
      this.bookingsService.groupTicketsBy = GroupTickets.PriceType;
    }
  }

  public openInvoiceEmailModal(): void {
    this.dialog.open(EmailModalComponent, {
      maxHeight: '100%',
      width: '50%',
      data: <EmailDialogData>{
        invoiceUuid: this.booking?.invoiceUuid,
        prefilledAddress: (this.booking?.customer?.email || null),
        isLinkPayValid: this.authService.checkPrivileges(Privileges.BOOKING_PAYMENT_LINK) && this.booking.type !== BookingType.Organiser,
        bookingStatus: this.booking?.status
      }
    });
  }

  public selectLegalPerson(legalPerson: LegalPerson): void {
    if (this.booking.legalPersonId !== legalPerson?.id) {
      this.bookingChanged = true;
    }
    this.selectedLegalPerson = legalPerson;
    this.booking.legalPersonId = legalPerson.id;
    this.customerLegalPerson = { id: legalPerson.id, name: legalPerson.companyName } as LegalPersonList;
    this.bookingLegalPersonScrollLoad.object = legalPerson;
    this.showLegalPersonForm = false;
  }

  public cancelLegalPersonChange(): void {
    this.booking.legalPersonId = this.selectedLegalPerson?.id;
    this.customerLegalPerson = { id: this.selectedLegalPerson?.id, name: this.selectedLegalPerson?.companyName } as LegalPersonList;
    this.bookingLegalPersonScrollLoad.object = this.selectedLegalPerson;
    this.showLegalPersonForm = false;
  }

  private resetLegalPerson(): void {
    this.booking.legalPersonId = null;
    this.bookingLegalPersonScrollLoad.reset();
    this.resetCustomer();
  }

  public selectCustomer(customer: Customer): void {
    if (this.booking.customer?.uuid !== customer?.uuid) {
      this.bookingChanged = true;
    }
    this.selectedCustomer = customer;
    this.booking.customer = customer;
    this.bookingCustomerScrollLoad.object = customer;
    this.showCustomerForm = false;
  }

  public cancelCustomerChange(): void {
    this.booking.customer = this.selectedCustomer;
    this.bookingCustomerScrollLoad.object = this.selectedCustomer;
    this.showCustomerForm = false;
  }

  private resetCustomer(): void {
    this.booking.customer = { legalPersons: [] };
    this.bookingCustomerScrollLoad.reset();
  }

  public displayCustomerForm(clearForm?: boolean): void {
    this.showCustomerForm = true;
    this.showLegalPersonForm = false;
    if (clearForm) {
      this.resetCustomer();
    }
  }

  public displayLegalPersonForm(clearForm?: boolean): void {
    this.showLegalPersonForm = true;
    this.showCustomerForm = false;
    if (clearForm) {
      this.resetLegalPerson();
    }
  }

  public checkDueDateChange(): void {
    if (!this.dueDate) {return;}
    if (!moment(this.booking.dueDate, 'X').endOf('day').isSame(moment(this.dueDate).endOf('day'))) {
      this.bookingChanged = true;
    }
  }

  public get canViewPaymentOptions(): boolean {
    return this.authService.checkPrivileges(Privileges.PAYMENT_OPTIONS) || (this.booking.type !== BookingType.Organiser && this.isPromoter && this.isSameOrganiser)
  }

  public get isChangeDisabled(): boolean {
    return (!this.bookingChanged && !this.internalCommentChanged) || !this.isValid;
  }

  public get pendingChangesDescription(): string {
    return this.translateService.instant('general.api_booking_description_unsaved_changes');
  }

  public saveAndContinue(): void {
    this.saveBookingChanges();
  }

  public get isValidClientNotificationEmail(): boolean {
    return !this.clientNotificationEmail || ValidationService.validateEmail(this.clientNotificationEmail);
  }

  public get canChooseTicketFormat(): boolean {
    return this.authService.checkPrivileges(Privileges.TICKET_TYPE_CHANGE)
      && !this.authService.checkSalespointProperty('tickets_printed_in_pdf')
      && !this.authService.checkSalespointProperty('fiscal_procedures_by');
  }
  public get canChoosePrintCount(): boolean {
    return this.authService.checkPrivileges(Privileges.TICKETS_PRINT_COUNT_BY)
      && this.ticketType === this.printTicketType.Pdf && this.bookingsService.ticketCount > 1;
  }

  @HostListener('window:beforeunload')
  public canDeactivate(): Observable<boolean> | boolean {
    return !this.bookingChanged && !this.internalCommentChanged;
  }

  protected readonly TextInputType = TextInputType;
  protected readonly NumericInputType = NumericInputType;
}
